import React, { useState } from 'react';
import { useAuth } from 'context/AuthContext';
import OTPVerification from './OTPVerification';

const UnverifiedUserHandler = ({ email, onVerificationComplete, onBack }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showOTPVerification, setShowOTPVerification] = useState(false);
  const [tempToken, setTempToken] = useState(null);
  const [user, setUser] = useState(null);
  
  const { requestOTP } = useAuth();

  const handleRequestOTP = async () => {
    setLoading(true);
    setError('');

    try {
      const result = await requestOTP(email);
      
      if (result.success) {
        setTempToken(result.temp_token);
        setUser({ email: email }); // We don't have full user data here
        setShowOTPVerification(true);
      } else {
        setError(result.error);
      }
    } catch (error) {
      setError('Failed to request OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleVerificationComplete = (verifiedUser, accessToken) => {
    if (onVerificationComplete) {
      onVerificationComplete(verifiedUser, accessToken);
    }
  };

  if (showOTPVerification) {
    return (
      <OTPVerification
        tempToken={tempToken}
        user={user}
        onVerificationComplete={handleVerificationComplete}
      />
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-white via-blue-50 to-blue-100">
      <div className="max-w-md w-full space-y-8 p-8">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="text-center">
            <img 
              src="/logo3.png" 
              alt="ChemSafe" 
              className="mx-auto h-12 w-auto mb-4"
            />
            <h2 className="text-3xl font-bold text-gray-800 mb-2">Email Not Verified</h2>
            <p className="text-gray-600">
              The email <strong>{email}</strong> is registered but not verified.
            </p>
          </div>

          <div className="mt-8 space-y-6">
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">
                {error}
              </div>
            )}

            <div className="text-center space-y-4">
              <p className="text-sm text-gray-600">
                To complete your registration, you need to verify your email address.
              </p>
              
              <button
                onClick={handleRequestOTP}
                disabled={loading}
                className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                {loading ? (
                  <div className="flex items-center">
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                    Sending verification code...
                  </div>
                ) : (
                  'Send Verification Code'
                )}
              </button>

              {onBack && (
                <button
                  onClick={onBack}
                  className="w-full py-2 px-4 border border-gray-300 rounded-lg shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                >
                  Go Back
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnverifiedUserHandler;
